module.exports = __webpack_public_path__ + "media/images/remittees_2-550410f5a054a67c0e5f0e8e22633ec0.jpg";